export default {
  setReportColumns({commit, state}, columns){
    commit('setReportColumns', columns)
  },
  changePaginationItemLimit({dispatch, state, commit}, value)
  {
    commit('changePaginationItemLimit', value);
  },
  setReportPaginationFilter({dispatch, state, commit}, value)
  {
    commit('setReportPaginationFilter', value);
  },
  setUpdatingStatus({dispatch, state, commit}, value)
  {
    commit('setUpdatingStatus', value);
  },
  setChartUpdatingStatus({dispatch, state, commit}, value)
  {
    commit('setChartUpdatingStatus', value);
  },
  setReportSearch({dispatch, state, commit}, searchPhrase)
  {
    commit('setReportSearch', searchPhrase);
  },
  setPagination({dispatch, state, commit}, value)
  {
    commit('setPagination', value);
  },
  clearPagination({dispatch, state, commit})
  {
    commit('clearPagination');
  },
  startLoading({dispatch, state, commit})
  {
    commit('startLoading');
  },
  finishLoading({dispatch, state, commit})
  {
    commit('finishLoading');
  },
  updatePresetStatus({dispatch, state, commit}, value)
  {
    commit('updatePresetStatus', value);
  },
  setDateComparisonStatus({dispatch, state, commit}, value)
  {
    commit('setDateComparisonStatus', value);
  },


  setFilters({dispatch, state, commit}, filters)
  {
    commit('setFilters', filters);
  },

  setAdvancedFilters({dispatch, state, commit}, advancedFilters)
  {
    commit('setAdvancedFilters', advancedFilters);
  },

  updateFilter({dispatch, state, commit}, filterData)
  {
    commit('updateFilter', filterData);
  },

  updateAdvancedFilter({dispatch, commit}, filterData)
  {
    commit('updateAdvancedFilter', filterData);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/filter/actions.js